export const WeekType = {
    SUN: 'sun',
    MON: 'mon',
    TUE: 'tue',
    WED: 'wed',
    THU: 'thu',
    FRI: 'fri',
    SAT: 'sat',
    HOL: 'hol',
} as const;

export const WeekShortString = {
    sun: '日',
    mon: '月',
    tue: '火',
    wed: '水',
    thu: '木',
    fri: '金',
    sat: '土',
    hol: '祝',
} as const;

export const WeekLongString = {
    sun: '日曜日',
    mon: '月曜日',
    tue: '火曜日',
    wed: '水曜日',
    thu: '木曜日',
    fri: '金曜日',
    sat: '土曜日',
    hol: '祝日',
} as const;

export type WeekType = typeof WeekType[keyof typeof WeekType];

export const AllWeekType = Object.values(WeekType);

export function WeekTypesNumberToWeekTypes(weekTypes: number): WeekType[] {
    let week_conditions: WeekType[] = [];
    if (weekTypes & 1 << 0) week_conditions.push(WeekType.SUN)
    if (weekTypes & 1 << 1) week_conditions.push(WeekType.MON)
    if (weekTypes & 1 << 2) week_conditions.push(WeekType.TUE)
    if (weekTypes & 1 << 3) week_conditions.push(WeekType.WED)
    if (weekTypes & 1 << 4) week_conditions.push(WeekType.THU)
    if (weekTypes & 1 << 5) week_conditions.push(WeekType.FRI)
    if (weekTypes & 1 << 6) week_conditions.push(WeekType.SAT)
    if (weekTypes & 1 << 7) week_conditions.push(WeekType.HOL)
    return week_conditions
}
export function WeekTypesToWeekTypesNumber(weekTypes: WeekType[]): number {
    let week_conditions: number = 0
    if (weekTypes.includes(WeekType.SUN)) week_conditions |= 1 << 0
    if (weekTypes.includes(WeekType.MON)) week_conditions |= 1 << 1
    if (weekTypes.includes(WeekType.TUE)) week_conditions |= 1 << 2
    if (weekTypes.includes(WeekType.WED)) week_conditions |= 1 << 3
    if (weekTypes.includes(WeekType.THU)) week_conditions |= 1 << 4
    if (weekTypes.includes(WeekType.FRI)) week_conditions |= 1 << 5
    if (weekTypes.includes(WeekType.SAT)) week_conditions |= 1 << 6
    if (weekTypes.includes(WeekType.HOL)) week_conditions |= 1 << 7
    return week_conditions
}